import styled, { keyframes } from 'styled-components'
import { theme } from '@dasa-health/components-react'

const rotation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`

export const ContainerGlobal = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 100dvh;
`

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100%;

    @media (min-width: 768px) {
        padding-top: 80px;
        align-items: start;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    max-width: 26.5rem;
    padding: 0 1rem;

    & > h1 {
        text-align: center;
    }

    .title {
        margin-bottom: 1.5rem;
        font-weight: 700;
        font-size: 2.2rem;
        line-height: 3rem;
    }
`

export const Illustration = styled.img`
    margin: 0 0 2.5rem 0;
    max-width: 26.5rem;
`
export const IconSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    animation: ${rotation} 1s linear infinite;

    > svg {
        font-size: 30px;

        > path {
            stroke: ${theme.colors.white};
            stroke-width: 2;
        }
    }
`
export const Title = styled.h1`
    text-align: center;
    font-size: 32px;
    font-weight: 700;
    padding-bottom: 40px;
    line-height: 125%;
    letter-spacing: -1px;
`
export const ButtonWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
`
export const Subtitle = styled.p`
    text-align: center;
    padding-bottom: 40px;
    font-size: 16px;
    line-height: 1.5;

    strong {
        font-weight: 700;
    }
`

export const FixedButtonWrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    padding-bottom: 16px;

    @media (min-width: 768px) {
        position: static;
        box-shadow: none;
        width: 110%;
    }
`
